<ngx-loading [show]="loading"></ngx-loading>

<div class='col-md-12 col-sm-12 col-xs-12'>
  <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 reviewbottom">
    <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview">
      <span><img [src]="logo_url" class="img-responsive" *ngIf="logo_url != undefined">
        <span class="bus_name_review">{{business_name}}</span></span>
      <!-- <p>Your experience is what matters to us. <br/>Review your experience with us!</p> -->
    </div>
    <div class="col-md-12 col-col-sm-12 col-xs-12 text-center">
      <h5>{{reviewp}} {{customer_name}}</h5>
      <p>{{reviewp1}}</p>
    </div>
    <!-- 2 point scale -->
    <ng-container *ngIf="feedback_scale == '2'">
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center" *ngIf="consumer_choice == 'Friendly'">
        <p>Click any of our Smiley's below:</p>
        <ul class="emojis">
          <li>
            <a title="Sad" (click)='openSocialReviewSad()' [ngStyle]="reviewdislikeStyle" style="background: #fff;"><img
                src="{{reviewdislike}}" width="60px"></a>
          </li>
          <li>
            <a (click)="openSocialReviewSmiley()" [ngStyle]="reviewlikeStyle" title="Happy" style="background: #fff;">
              <img src="{{reviewlike}}" width="60px"></a>
          </li>

        </ul>
      </div>
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center" *ngIf="consumer_choice == 'Formal'">
        <p>Click any of our Icon's below:</p>
        <ul class="emojis">
          <li>
            <a (click)="openSocialReviewThumbsUp()" [ngStyle]="reviewlikeStyle1" title="Happy"
              style="background: #fff;"> <img src="{{reviewlike1}}" width="35px"></a>
          </li>
          <li>
            <a title="Sad" (click)='openSocialReviewThumbsDown()' [ngStyle]="reviewdislikeStyle1"
              style="background: #fff;"><img src="{{reviewdislike1}}" width="35px"></a>
          </li>
        </ul>
      </div>
    </ng-container>
    <!-- 5 point scale -->
    <ng-container *ngIf="feedback_scale == '5'">
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center" *ngIf="consumer_choice == 'Friendly'">
        <p>Click any of our Smiley's below:</p>
        <ol class="smileylist onlysmileys">
          <li>
            <img (click)="sendScaleValueFaces(1)" src="assets/images/social/1-verypoor.svg">
          </li>
          <li>
            <img (click)="sendScaleValueFaces(2)" src="assets/images/social/2-poor.svg">
          </li>
          <li>
            <img (click)="sendScaleValueFaces(3)" src="assets/images/social/3-average.svg">
          </li>
          <li>
            <img (click)="sendScaleValueFaces(4)" src="assets/images/social/4-good.svg">
          </li>
          <li>
            <img (click)="sendScaleValueFaces(5)" src="assets/images/social/5-excellent.svg">
          </li>


        </ol>
      </div>
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center" *ngIf="consumer_choice == 'Formal'">
        <p>Click any of our Icon's below:</p>
        <!-- <ul class="emojis">
              <li>
                  <a (click)="openSocialReviewThumbsUp()" [ngStyle]="reviewlikeStyle1" title="Happy" style="background: #fff;"> <img src="{{reviewlike1}}" width="35px"></a>
              </li>
              <li>
                  <a title="Sad" (click)='openSocialReviewThumbsDown()' [ngStyle]="reviewdislikeStyle1" style="background: #fff;"><img src="{{reviewdislike1}}" width="35px"></a>
              </li>
            </ul> -->
        <ol class="smileylist">
          <li (click)="sendScaleValue(1)"></li>
          <li (click)="sendScaleValue(2)"></li>
          <li (click)="sendScaleValue(3)"></li>
          <li (click)="sendScaleValue(4)"></li>
          <li (click)="sendScaleValue(5)"></li>
        </ol>
      </div>

    </ng-container>
    <!-- 10 point scale -->
    <ng-container *ngIf="feedback_scale == '10'">
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center" *ngIf="consumer_choice == 'Formal'">
        <ng-container>
          <div class="custom-slider mx-1">
            <ngx-slider [(value)]="tenPointValue" [options]="options"></ngx-slider>
          </div>
          <div class='col-md-12 col-sm-12 text-center mt-5 mb-3'>
            <button class='btn-primary btn' type="button" (click)='onSubmitTenPointScale()' [disabled]="tenPointValueSubmitted">
              Submit Feedback
            </button>
          </div>
        </ng-container>
      </div>
    </ng-container>

        <div class="col-md-12 col-col-sm-12 col-xs-12 text-center">
          <span class="mr-2">Receive notifications via WhatsApp</span>
          <label class="switch mb-0">
            <input type="checkbox" id="togBtn" [(ngModel)]="optionForWhatsApp"  (ngModelChange)="optedinWhatsApp(optionForWhatsApp)"
              [ngModelOptions]="{standalone: true}">
            <div class="slider round">
              <!--ADDED HTML -->
              <span class="on">Enabled</span><span class="off">Disabled</span>
              <!--END-->
            </div>
          </label>
        </div>
  </div>
</div>
<footer>
  <div class="col-md-12 col-col-sm-12 col-xs-12">
    <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter">
      <p>{{poweredby}}</p>
      <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=review_invite" target="_blank">
        <img src="{{poweredby1}}" class="img-responsive">
      </a>
    </div>
  </div>
</footer>

<ng-template #needimproveModal>
  <div class='col-lg-12 col-md-12 col-sm-12 feedbackimprove'>
    <h4>Please share your feedback to help us improve!</h4>
    <div class='col-md-12 col-sm-12'>
      <div class="form-group">
        <textarea placeholder="Feedback" [(ngModel)]="feedback"></textarea>
      </div>
      <!-- hide star rating -->
      <div *ngIf="false" class="form-group text-center">
        <ngb-rating class='star-rating' [starTemplate]="ratingStar" [(rate)]="selected_rating" (hover)="ratings=$event"
          (leave)="hovered=0" [readonly]="readonly" ></ngb-rating>
      </div>
    </div>
    <div class='col-md-12 col-sm-12 text-center'>
      <button class='action-button btn' (click)='thankyouModal()'>
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #thankyoumodal>
  <div class='col-lg-12 col-md-12 col-sm-12 feedbackimprove'>
    <!-- <h3>Thank you for your feedback. We will look into it and get back to you shortly</h3> -->
    <!-- <h3>Thanks for providing your feedback. We will now redirect you to {{ auto_redirect}} where you can choose to post
      it.</h3> -->
    <h3 class="thankyou-modal-text">Thank you for your feedback. <br> We are sorry you had a bad experience. We will reach out to
      address your feedback. Please <a [href]="redirectLink" class="hyper-link-text" >click here</a> to review us.</h3>
    <div class='col-md-12 col-sm-12 text-center'>
      <button class='action-button btn' (click)='closeModal()'>
        Ok
      </button>
    </div>
  </div>

</ng-template>

<ng-template #ratingStar let-fill="fill">
  <span class="star" [class.full-star]="fill === 100">
    <span class="half-star" [style.width.%]="fill">&#9733;</span>&#9733;
  </span>
</ng-template>
